/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  CapitalGiroReportRequestDto,
  CreateLoanOperationDto,
  CreateSubsequentInstallmentsDto,
  DividaReportRequestDto,
  GetApiV1LoanOperations200,
  GetApiV1LoanOperationsAdditionalIof200,
  GetApiV1LoanOperationsCalendar200,
  GetApiV1LoanOperationsCalendarParams,
  GetApiV1LoanOperationsFixedIof200,
  GetApiV1LoanOperationsId200,
  GetApiV1LoanOperationsIdParams,
  GetApiV1LoanOperationsInstallments4131CalculateAllIn200,
  GetApiV1LoanOperationsInstallments4131CalculateAllInParams,
  GetApiV1LoanOperationsInstallments4131CalculateInterestRateComposition200,
  GetApiV1LoanOperationsInstallments4131CalculateInterestRateCompositionParams,
  GetApiV1LoanOperationsInstallmentsFlow200,
  GetApiV1LoanOperationsInstallmentsFlowParams,
  GetApiV1LoanOperationsInterestTypes200,
  GetApiV1LoanOperationsInterestTypesParams,
  GetApiV1LoanOperationsIrPercentage200,
  GetApiV1LoanOperationsLoanOperationIdAttachments200,
  GetApiV1LoanOperationsLoanOperationIdAttachmentsParams,
  GetApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement200,
  GetApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlementParams,
  GetApiV1LoanOperationsLoanOperationTypes200,
  GetApiV1LoanOperationsParams,
  GetApiV1LoanOperationsSummaryByStatus200,
  GetApiV1LoanOperationsSummaryByStatusParams,
  GetApiV1LoanOperationsTypes200,
  LinkDerivativesDto,
  PostApiV1LoanOperationsByIds200,
  PostApiV1LoanOperationsLoanOperationIdAttachmentsBody,
  PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachments200,
  PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsBody,
  PostApiV1LoanOperationsParams,
  PostApiV1LoanOperationsReprocessInterestBasis200,
  PostApiV1LoanOperationsReprocessInterestBasisParams,
  PutApiV1LoanOperationsId200,
  ResultObject,
  RevertSettlementDto,
  SettleInstallmentDto,
  UpdateLoanOperationDto
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getLoanOperation = () => {
/**
 * Gera o relatório de Capital de Giro para operações do tipo WORKING_CAPITAL. O relatório inclui: estrutura da operação, comparativo de custo, fluxo de parcelas com status de liquidação e tabela de fluxo de caixa projetado. Retorna erro 400 se a operação não for do tipo WORKING_CAPITAL. Suporta formatos PDF e HTML.
 * @summary Exporta relatório de Capital de Giro
 */
const postLoanOperationsLoanOperationIdCapitalGiroReport = (
    loanOperationId: string,
    capitalGiroReportRequestDto?: CapitalGiroReportRequestDto,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/loan-operations/${loanOperationId}/capital-giro-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: capitalGiroReportRequestDto,
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Deleta o documento da operação de crédito.
 */
const deleteLoanOperationsLoanOperationIdAttachmentsAttachmentId = (
    loanOperationId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}/attachments/${attachmentId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Deleta uma operação de crédito.
 */
const deleteLoanOperationsLoanOperationId = (
    loanOperationId: string,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Remove um anexo de uma parcela específica de uma operação de crédito.
 */
const deleteLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsAttachmentId = (
    loanOperationId: string,
    installmentId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}/installments/${installmentId}/attachments/${attachmentId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Gera o relatório de Dívida Externa em 3 páginas para operações do tipo Repasse Externo (FOREIGN_REPASS). O relatório inclui: estrutura da operação, composição da taxa (waterfall), comparativo de custo, diagrama de payoff NDF+CAP e tabela de fluxo de caixa. Retorna erro 400 se a operação não for do tipo FOREIGN_REPASS. Suporta formatos PDF e HTML.
 * @summary Exporta relatório de Dívida Externa (Lei 4.131)
 */
const postLoanOperationsLoanOperationIdDividaReport = (
    loanOperationId: string,
    dividaReportRequestDto?: DividaReportRequestDto,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/loan-operations/${loanOperationId}/divida-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dividaReportRequestDto,
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Obtém as opcoes dos enums relacionados ao processo de Operações de Crédito.
 */
const getLoanOperationsTypes = (

 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsTypes200>>,) => {
      return customInstance<GetApiV1LoanOperationsTypes200>(
      {url: `/api/v1/loan-operations/types`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obtém as opcoes de modalidades.
 */
const getLoanOperationsLoanOperationTypes = (

 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsLoanOperationTypes200>>,) => {
      return customInstance<GetApiV1LoanOperationsLoanOperationTypes200>(
      {url: `/api/v1/loan-operations/loan-operation-types`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obtém as opcoes do enum InterestRateCalculationType (Calculo Juros) relacionados ao processo de Operações de Crédito.
 */
const getLoanOperationsInterestTypes = (
    params?: GetApiV1LoanOperationsInterestTypesParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsInterestTypes200>>,) => {
      return customInstance<GetApiV1LoanOperationsInterestTypes200>(
      {url: `/api/v1/loan-operations/interest-types`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obtém as taxas fixas do IOF.
 */
const getLoanOperationsFixedIof = (

 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsFixedIof200>>,) => {
      return customInstance<GetApiV1LoanOperationsFixedIof200>(
      {url: `/api/v1/loan-operations/fixed-iof`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obtém as taxas adicionais do IOF.
 */
const getLoanOperationsAdditionalIof = (

 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsAdditionalIof200>>,) => {
      return customInstance<GetApiV1LoanOperationsAdditionalIof200>(
      {url: `/api/v1/loan-operations/additional-iof`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obtém as as aliquotas do IR.
 */
const getLoanOperationsIrPercentage = (

 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsIrPercentage200>>,) => {
      return customInstance<GetApiV1LoanOperationsIrPercentage200>(
      {url: `/api/v1/loan-operations/ir-percentage`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obtém uma operação de crédito filtrado por id.
 */
const getLoanOperationsId = (
    id: string,
    params?: GetApiV1LoanOperationsIdParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsId200>>,) => {
      return customInstance<GetApiV1LoanOperationsId200>(
      {url: `/api/v1/loan-operations/${id}`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Edita uma operacao de credito.
 */
const putLoanOperationsId = (
    id: string,
    updateLoanOperationDto?: UpdateLoanOperationDto,
 options?: SecondParameter<typeof customInstance<PutApiV1LoanOperationsId200>>,) => {
      return customInstance<PutApiV1LoanOperationsId200>(
      {url: `/api/v1/loan-operations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateLoanOperationDto
    },
      options);
    }
  /**
 * @summary Obtém múltiplas operações de crédito filtradas por uma lista de IDs.
 */
const postLoanOperationsByIds = (
    postLoanOperationsByIdsBody?: string[],
 options?: SecondParameter<typeof customInstance<PostApiV1LoanOperationsByIds200>>,) => {
      return customInstance<PostApiV1LoanOperationsByIds200>(
      {url: `/api/v1/loan-operations/by-ids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postLoanOperationsByIdsBody
    },
      options);
    }
  /**
 * @summary Obtém todos as operações de crédito filtradas por paginação.
 */
const getLoanOperations = (
    params?: GetApiV1LoanOperationsParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperations200>>,) => {
      return customInstance<GetApiV1LoanOperations200>(
      {url: `/api/v1/loan-operations`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Cria uma nova operação de crédito.
 */
const postLoanOperations = (
    createLoanOperationDto?: CreateLoanOperationDto,
    params?: PostApiV1LoanOperationsParams,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLoanOperationDto,
        params
    },
      options);
    }
  /**
 * @summary Obtém todos os anexos referentes a uma operação de crédito filtrados por paginação.
 */
const getLoanOperationsLoanOperationIdAttachments = (
    loanOperationId: string,
    params?: GetApiV1LoanOperationsLoanOperationIdAttachmentsParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsLoanOperationIdAttachments200>>,) => {
      return customInstance<GetApiV1LoanOperationsLoanOperationIdAttachments200>(
      {url: `/api/v1/loan-operations/${loanOperationId}/attachments`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Faz o upload de um documento para a operação de crédito.
 */
const postLoanOperationsLoanOperationIdAttachments = (
    loanOperationId: string,
    postLoanOperationsLoanOperationIdAttachmentsBody?: PostApiV1LoanOperationsLoanOperationIdAttachmentsBody,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {const formData = new FormData();
if(postLoanOperationsLoanOperationIdAttachmentsBody?.files !== undefined) {
 postLoanOperationsLoanOperationIdAttachmentsBody?.files.forEach(value => formData.append(`files`, value as Blob));
 }

      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}/attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Obtém os dados (cálculo de liquidação) de uma parcela específica de uma operação de crédito.
 */
const getLoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement = (
    loanOperationId: string,
    installmentId: string,
    params?: GetApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlementParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement200>>,) => {
      return customInstance<GetApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement200>(
      {url: `/api/v1/loan-operations/${loanOperationId}/installments/${installmentId}/settlement`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Liquida uma parcela específica de uma operação de crédito.
 */
const putLoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement = (
    loanOperationId: string,
    installmentId: string,
    settleInstallmentDto?: SettleInstallmentDto,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}/installments/${installmentId}/settlement`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: settleInstallmentDto
    },
      options);
    }
  /**
 * @summary Obtém os eventos do calendário para um período específico refernte aos empréstimos.

Este método retorna uma lista detalhada de dias com eventos programados, incluindo operações de empréstimos
 */
const getLoanOperationsCalendar = (
    params?: GetApiV1LoanOperationsCalendarParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsCalendar200>>,) => {
      return customInstance<GetApiV1LoanOperationsCalendar200>(
      {url: `/api/v1/loan-operations/calendar`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obtém o fluxo de parcelas de empréstimos com filtros de data e hedge.
 */
const getLoanOperationsInstallmentsFlow = (
    params?: GetApiV1LoanOperationsInstallmentsFlowParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsInstallmentsFlow200>>,) => {
      return customInstance<GetApiV1LoanOperationsInstallmentsFlow200>(
      {url: `/api/v1/loan-operations/installments-flow`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Retorna um resumo das parcelas de operações de crédito agrupadas por status (Em Aberto, Vencidas, Liquidadas).
 */
const getLoanOperationsSummaryByStatus = (
    params?: GetApiV1LoanOperationsSummaryByStatusParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsSummaryByStatus200>>,) => {
      return customInstance<GetApiV1LoanOperationsSummaryByStatus200>(
      {url: `/api/v1/loan-operations/summary-by-status`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obtém as parcelas de acordo com o fluxo de pagamentos.
 */
const postLoanOperationsInstallments = (
    createSubsequentInstallmentsDto?: CreateSubsequentInstallmentsDto,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/installments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubsequentInstallmentsDto
    },
      options);
    }
  /**
 * @summary Obtém as parcelas de acordo com o fluxo de pagamentos para empréstimos tipo bullet.
 */
const postLoanOperationsInstallments4131Bullet = (
    createSubsequentInstallmentsDto?: CreateSubsequentInstallmentsDto,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/installments/4131/bullet`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubsequentInstallmentsDto
    },
      options);
    }
  /**
 * @summary Calcula a composição da taxa de juros para operações 4131, retornando o IR ajustado,
o IR sobre os juros e a comissão interna residual.
 */
const getLoanOperationsInstallments4131CalculateInterestRateComposition = (
    params?: GetApiV1LoanOperationsInstallments4131CalculateInterestRateCompositionParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsInstallments4131CalculateInterestRateComposition200>>,) => {
      return customInstance<GetApiV1LoanOperationsInstallments4131CalculateInterestRateComposition200>(
      {url: `/api/v1/loan-operations/installments/4131/calculate-interest-rate-composition`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Calcula o All-In anualizado para operações 4131.
Fórmula: AllIn = interestRate + (flatFee / (diffDias / 360)).
Quando flatFee = 0 ou as datas são iguais, AllIn = interestRate.
Retorna também os fatores intermediários para memória de cálculo no frontend.
 */
const getLoanOperationsInstallments4131CalculateAllIn = (
    params?: GetApiV1LoanOperationsInstallments4131CalculateAllInParams,
 options?: SecondParameter<typeof customInstance<GetApiV1LoanOperationsInstallments4131CalculateAllIn200>>,) => {
      return customInstance<GetApiV1LoanOperationsInstallments4131CalculateAllIn200>(
      {url: `/api/v1/loan-operations/installments/4131/calculate-all-in`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Faz o upload de anexos para uma parcela específica de uma operação de crédito.
 */
const postLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachments = (
    loanOperationId: string,
    installmentId: string,
    postLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsBody?: PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsBody,
 options?: SecondParameter<typeof customInstance<PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachments200>>,) => {const formData = new FormData();
if(postLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsBody?.files !== undefined) {
 postLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsBody?.files.forEach(value => formData.append(`files`, value as Blob));
 }

      return customInstance<PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachments200>(
      {url: `/api/v1/loan-operations/${loanOperationId}/installments/${installmentId}/attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * @summary Vincula um conjunto de operações de derivativos a uma parcela.
 */
const postLoanOperationsLoanOperationIdInstallmentsInstallmentIdDerivatives = (
    loanOperationId: string,
    installmentId: string,
    linkDerivativesDto?: LinkDerivativesDto,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}/installments/${installmentId}/derivatives`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: linkDerivativesDto
    },
      options);
    }
  /**
 * @summary Reverte a liquidação de uma parcela específica de uma operação de crédito.
 */
const putLoanOperationsLoanOperationIdInstallmentsInstallmentIdRevertSettlement = (
    loanOperationId: string,
    installmentId: string,
    revertSettlementDto?: RevertSettlementDto,
 options?: SecondParameter<typeof customInstance<ResultObject>>,) => {
      return customInstance<ResultObject>(
      {url: `/api/v1/loan-operations/${loanOperationId}/installments/${installmentId}/revert-settlement`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: revertSettlementDto
    },
      options);
    }
  /**
 * @summary Reprocessa os campos de juros normalizados por base (252/360/365) para todas as parcelas existentes.
Utiliza os serviços de cálculo originais (4131, Capital de Giro V1 e V2) para garantir que os valores
sejam recalculados com a mesma lógica usada na geração inicial das parcelas.
 */
const postLoanOperationsReprocessInterestBasis = (
    params?: PostApiV1LoanOperationsReprocessInterestBasisParams,
 options?: SecondParameter<typeof customInstance<PostApiV1LoanOperationsReprocessInterestBasis200>>,) => {
      return customInstance<PostApiV1LoanOperationsReprocessInterestBasis200>(
      {url: `/api/v1/loan-operations/reprocess-interest-basis`, method: 'POST',
        params
    },
      options);
    }
  return {postLoanOperationsLoanOperationIdCapitalGiroReport,deleteLoanOperationsLoanOperationIdAttachmentsAttachmentId,deleteLoanOperationsLoanOperationId,deleteLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsAttachmentId,postLoanOperationsLoanOperationIdDividaReport,getLoanOperationsTypes,getLoanOperationsLoanOperationTypes,getLoanOperationsInterestTypes,getLoanOperationsFixedIof,getLoanOperationsAdditionalIof,getLoanOperationsIrPercentage,getLoanOperationsId,putLoanOperationsId,postLoanOperationsByIds,getLoanOperations,postLoanOperations,getLoanOperationsLoanOperationIdAttachments,postLoanOperationsLoanOperationIdAttachments,getLoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement,putLoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement,getLoanOperationsCalendar,getLoanOperationsInstallmentsFlow,getLoanOperationsSummaryByStatus,postLoanOperationsInstallments,postLoanOperationsInstallments4131Bullet,getLoanOperationsInstallments4131CalculateInterestRateComposition,getLoanOperationsInstallments4131CalculateAllIn,postLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachments,postLoanOperationsLoanOperationIdInstallmentsInstallmentIdDerivatives,putLoanOperationsLoanOperationIdInstallmentsInstallmentIdRevertSettlement,postLoanOperationsReprocessInterestBasis}};
export type PostApiV1LoanOperationsLoanOperationIdCapitalGiroReportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsLoanOperationIdCapitalGiroReport']>>>
export type DeleteApiV1LoanOperationsLoanOperationIdAttachmentsAttachmentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['deleteLoanOperationsLoanOperationIdAttachmentsAttachmentId']>>>
export type DeleteApiV1LoanOperationsLoanOperationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['deleteLoanOperationsLoanOperationId']>>>
export type DeleteApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsAttachmentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['deleteLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsAttachmentId']>>>
export type PostApiV1LoanOperationsLoanOperationIdDividaReportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsLoanOperationIdDividaReport']>>>
export type GetApiV1LoanOperationsTypesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsTypes']>>>
export type GetApiV1LoanOperationsLoanOperationTypesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsLoanOperationTypes']>>>
export type GetApiV1LoanOperationsInterestTypesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsInterestTypes']>>>
export type GetApiV1LoanOperationsFixedIofResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsFixedIof']>>>
export type GetApiV1LoanOperationsAdditionalIofResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsAdditionalIof']>>>
export type GetApiV1LoanOperationsIrPercentageResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsIrPercentage']>>>
export type GetApiV1LoanOperationsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsId']>>>
export type PutApiV1LoanOperationsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['putLoanOperationsId']>>>
export type PostApiV1LoanOperationsByIdsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsByIds']>>>
export type GetApiV1LoanOperationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperations']>>>
export type PostApiV1LoanOperationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperations']>>>
export type GetApiV1LoanOperationsLoanOperationIdAttachmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsLoanOperationIdAttachments']>>>
export type PostApiV1LoanOperationsLoanOperationIdAttachmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsLoanOperationIdAttachments']>>>
export type GetApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlementResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement']>>>
export type PutApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlementResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['putLoanOperationsLoanOperationIdInstallmentsInstallmentIdSettlement']>>>
export type GetApiV1LoanOperationsCalendarResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsCalendar']>>>
export type GetApiV1LoanOperationsInstallmentsFlowResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsInstallmentsFlow']>>>
export type GetApiV1LoanOperationsSummaryByStatusResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsSummaryByStatus']>>>
export type PostApiV1LoanOperationsInstallmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsInstallments']>>>
export type PostApiV1LoanOperationsInstallments4131BulletResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsInstallments4131Bullet']>>>
export type GetApiV1LoanOperationsInstallments4131CalculateInterestRateCompositionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsInstallments4131CalculateInterestRateComposition']>>>
export type GetApiV1LoanOperationsInstallments4131CalculateAllInResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['getLoanOperationsInstallments4131CalculateAllIn']>>>
export type PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsLoanOperationIdInstallmentsInstallmentIdAttachments']>>>
export type PostApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdDerivativesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsLoanOperationIdInstallmentsInstallmentIdDerivatives']>>>
export type PutApiV1LoanOperationsLoanOperationIdInstallmentsInstallmentIdRevertSettlementResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['putLoanOperationsLoanOperationIdInstallmentsInstallmentIdRevertSettlement']>>>
export type PostApiV1LoanOperationsReprocessInterestBasisResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getLoanOperation>['postLoanOperationsReprocessInterestBasis']>>>
